import request from '../../axios/axiosconfig.js'

/**
 * 查询订单列表
 * @param {*} params
 * @returns
 */
export function getAllOrder(params) {
  return request({
    url: '/ps/powerBankOrder/getAllOrder',
    method: 'get',
    params: params,
    timeout: 20000
  })
}

/**
 * 查询订单详情
 * @param {*} orderId
 * @returns
 */
export function getOrderInfo(orderId) {
  return request({
    url: '/ps/powerBankOrder/getOrderDetailByOrderId/' + orderId,
    method: 'get'
  })
}

/**
 * 订单标注
 * @param {*} freeOrderDto
 * @returns
 */
export function remarkOrder(remarkOrderDto) {
  return request({
    url: '/ps/powerBankOrder/remarkOrder',
    method: 'post',
    data: remarkOrderDto
  })
}

/**
 * 订单免单
 * @param {*} freeOrderDto
 * @returns
 */
export function freeOrder(freeOrderDto) {
  return request({
    url: '/ps/powerBankOrder/freeOrderVrfinal',
    method: 'post',
    data: freeOrderDto
  })
}

/**
 * 暂停订单
 * @param {*} stopOrderDto
 * @returns
 */
export function stopOrder(stopOrderDto) {
  return request({
    url: '/ps/powerBankOrder/stopOrder',
    method: 'post',
    data: stopOrderDto
  })
}
export function recovery(orderId) {
  return request({
    url: '/ps/powerBankOrder/recovery/' + orderId,
    method: 'get'
  })
}
export function revoke(orderId,reason) {
  return request({
    url: '/ps/powerBankOrder/revokeOrder/' + orderId,
    method: 'get',
    params: reason
  })
}

/**
 * 强制结束订单
 * @param {*} forcedEndDto
 * @returns
 */
export function forcedEnd(forcedEndDto) {
  return request({
    url: '/ps/powerBankOrder/forcedEnd',
    method: 'post',
    data: forcedEndDto
  })
}

export function refund(refund) {
  return request({
    url: '/ps/powerBankOrder/refund',
    method: 'post',
    data: refund
  })
}



// WEBPACK FOOTER //
// ./src/api/oder/powerbankorder.js